import React from 'react';
import axios from 'axios';

import Loading from '../components/Loading.jsx';

const sendEmail = async (freq, type, users) => {
    try {
        const { data } = await axios.request({
            url: `/sop/send-reminder`,
            method: 'POST',
            data: {
                freq_type: freq,
                msg_type: type,
                users: users
            }
        });
        return data;
    } catch (error) {
        throw error;
    }
};

const SopButton = (props) => {
    const [sending, setSending] = React.useState(false);

    const handleSend = async () => {
        setSending(true);
        let users = null;
        if (props.user) {
            users = {};
            users[props.user.email] = {
                name: `${props.user.name}`,
                email: props.user.email,
                subs: props.user.subs.map((sub) => {
                    return {
                        name: sub.description,
                        id: sub.internal_id
                    };
                })
            };
        }
        try {
            await sendEmail(props.freq, props.type, users);
            setSending(false);
        } catch {
            setSending(false);
        }
    };
    return (
        <button className="button" type="button" onClick={handleSend}>
            {sending && <Loading inline />}
            {!sending && props.children}
        </button>
    );
};

export default SopButton;
